import { memo, useState } from "react";
import './expandableView.scss';

export interface ExpandableViewProps {
    items: string[];
    isExpanded: boolean;
}

const ExpandableView = ({ items, isExpanded }: ExpandableViewProps) => {

    const [open, setOpen] = useState(isExpanded);

    const handleOpen = () => {
        setOpen(!open);
    };

    return (
        <div data-testid="expandable-view">
            <button onClick={handleOpen} role="button" aria-label="expand-button" className={`expand-button ` + (open ? 'expanded' : '')}>
                <span className="expand-icon" role="button" aria-label="Expand details" title="Expand details" tabIndex={0}>
                    <svg width="10" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 25 25">
                        <title>Expand details</title>
                        <path d="M11.3 19.2L.6 8.3c-.7-.7-.7-1.8 0-2.5s1.8-.7 2.5 0l9.5 9.7 9.3-9.7c.7-.7 1.8-.7 2.5 0s.7 1.8 0 2.5L13.7 19.2c-.3.3-.8.5-1.2.5-.5.1-.9-.1-1.2-.5z" />
                    </svg>
                </span>
            </button>
            <div className="menu-wrapper">
                {open ? (
                    <ul className="menu">
                        {items.map((item: string) => (
                            <li key={item} className="menu-item">
                                <a className="item-link" href={item}> {item} </a>
                            </li>
                        ))}
                    </ul>
                ) : null}
            </div>
        </div>
    );

};

export default memo(ExpandableView);